import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getClientNotebooks } from 'api/clients'
import { dateTimeToString, getCurrentMonth } from 'utils/date'
import InformationTable from 'components/InformationTable/InformationTable'
import MonthSelector from 'elements/MonthSelector/MonthSelector'
import YearSelector from 'elements/YearSelector/YearSelector'
import CuadernilloCell from 'components/InformationTable/cells/CuadernilloCell/CuadernilloCell'
import styles from './CuadernillosCliente.module.css'

const CuadernillosCliente = () => {
  const { id } = useParams()
  const [date, setDate] = useState(getCurrentMonth())
  const [classes, setClasses] = useState([])

  useEffect(() => {
    setClasses([])
    getClientNotebooks({ clientId: id, ...date })
      .then(setClasses)
      .catch(console.error)
  }, [id, date])

  const handleDateChange = key => e => {
    const value = e.target.value
    setDate(currentDate => ({
      ...currentDate,
      [key]: value
    }))
  }

  return (
    <div>
      <div className={styles.filter}>
        <MonthSelector
          value={date.month}
          onChange={handleDateChange('month')}
        />
        <YearSelector value={date.year} onChange={handleDateChange('year')} />
      </div>
      <InformationTable
        details={[
          {
            title: 'Fecha y hora',
            key: 'date',
            align: 'left',
            sortDisabled: true
          },

          {
            title: 'Cuadernillo',
            key: 'notebook',
            align: 'left',
            sortDisabled: true
          },
          { title: 'Profesor', key: 'teacher', sortDisabled: true }
        ]}
        data={classes.map(notebookSelection => ({
          _id: notebookSelection.id,
          date: dateTimeToString(notebookSelection.date),
          teacher: notebookSelection.teacherName,
          title: notebookSelection.title ? notebookSelection.title : '--',
          notebook: <CuadernilloCell cuadernillo={notebookSelection} />
        }))}
      />
    </div>
  )
}

export default CuadernillosCliente
